import { useState, useEffect } from "react";
import { CONSENT_KEY, grantConsent } from "@/lib/tracking";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(CONSENT_KEY);
    if (choice === "granted") {
      grantConsent();
    } else if (!choice) {
      setVisible(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "granted");
    grantConsent();
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(CONSENT_KEY, "denied");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 mx-auto max-w-[480px] w-full z-[60] px-4 pb-4 animate-fade-up"
    >
      <div className="bg-[#1C1613] text-[#FFFFFF] rounded-2xl p-5 shadow-[0_8px_30px_rgba(0,0,0,0.25)]">
        <p className="text-sm leading-relaxed text-[#E6DDD4]">
          Nous utilisons des cookies pour mesurer l'efficacité de nos publicités.
          Vous pouvez accepter ou refuser leur utilisation.
        </p>
        <div className="mt-4 flex gap-3">
          <button
            data-testid="cookie-refuse-btn"
            onClick={refuse}
            className="flex-1 h-11 rounded-full border border-[#8C7A70] text-[#FFFFFF] text-sm font-semibold transition-colors hover:bg-white/5"
          >
            Refuser
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={accept}
            className="flex-1 h-11 rounded-full bg-[#C84C2C] text-white text-sm font-semibold transition-transform active:scale-[0.98] hover:bg-[#B23E20]"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};
